import { motion } from "framer-motion";
import { PILLARS } from "@/config/site";

export const BusinessPillars = ({ detailed = false }) => (
  <div className="grid border-t hairline sm:grid-cols-2 lg:grid-cols-4" data-testid="business-pillars">
    {PILLARS.map((p, i) => (
      <motion.div
        key={p.n}
        className="group relative border-b hairline py-10 sm:px-6 lg:border-b-0 lg:border-l first:lg:border-l-0 first:sm:pl-0"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
        data-testid={`pillar-${p.n}`}
      >
        <span className="absolute left-0 top-[-1px] h-[2px] w-0 bg-[linear-gradient(90deg,var(--sky),var(--rose))] transition-[width] duration-700 group-hover:w-full" />
        <span className="font-display text-6xl font-light italic text-[var(--sky-ink)] group-odd:text-[var(--sky-ink)] group-even:text-[var(--rose-ink)]">{p.n}</span>
        <h3 className="mt-8 text-xl font-semibold tracking-tight">{p.title}</h3>
        <p className="mt-3 max-w-xs leading-relaxed text-[var(--ink-2)]">{p.text}</p>
        {detailed && p.more && <p className="mt-4 max-w-xs text-sm leading-relaxed text-[var(--ink-2)]">{p.more}</p>}
      </motion.div>
    ))}
  </div>
);
